(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buttom-detalle"] && !Shopify.designMode) return;
  try {
    // BUTTOM 18/10/2026: cuando cambia la variante, el tema (Horizon) trae la página nueva y avisa con "variant:update"
  // (e.detail.data.html = el documento nuevo). Cada bloque marcado con data-buttom-sigue copia su versión nueva.
  if (!window.__buttomSigueVariante) {
    window.__buttomSigueVariante = true;
    document.addEventListener('variant:update', function (e) {
      var html = e.detail && e.detail.data && e.detail.data.html;
      if (!html) return;
      document.querySelectorAll('[data-buttom-sigue]').forEach(function (el) {
        var nuevo = html.querySelector('[data-buttom-sigue="' + el.getAttribute('data-buttom-sigue') + '"]');
        if (nuevo) el.innerHTML = nuevo.innerHTML;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buttom-ficha-aroma"] && !Shopify.designMode) return;
  try {
    // BUTTOM 18/10/2026: cuando cambia la variante, el tema (Horizon) trae la página nueva y avisa con "variant:update"
  // (e.detail.data.html = el documento nuevo). Cada bloque marcado con data-buttom-sigue copia su versión nueva.
  if (!window.__buttomSigueVariante) {
    window.__buttomSigueVariante = true;
    document.addEventListener('variant:update', function (e) {
      var html = e.detail && e.detail.data && e.detail.data.html;
      if (!html) return;
      document.querySelectorAll('[data-buttom-sigue]').forEach(function (el) {
        var nuevo = html.querySelector('[data-buttom-sigue="' + el.getAttribute('data-buttom-sigue') + '"]');
        if (nuevo) el.innerHTML = nuevo.innerHTML;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buttom-precio-transferencia"] && !Shopify.designMode) return;
  try {
    // BUTTOM 18/10/2026: cuando cambia la variante, el tema (Horizon) trae la página nueva y avisa con "variant:update"
  // (e.detail.data.html = el documento nuevo). Cada bloque marcado con data-buttom-sigue copia su versión nueva.
  if (!window.__buttomSigueVariante) {
    window.__buttomSigueVariante = true;
    document.addEventListener('variant:update', function (e) {
      var html = e.detail && e.detail.data && e.detail.data.html;
      if (!html) return;
      document.querySelectorAll('[data-buttom-sigue]').forEach(function (el) {
        var nuevo = html.querySelector('[data-buttom-sigue="' + el.getAttribute('data-buttom-sigue') + '"]');
        if (nuevo) el.innerHTML = nuevo.innerHTML;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
